module.exports = __webpack_public_path__ + "static/media/arrow_down.29f22c75.svg";